import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { saveAs } from "file-saver";
import { APP_ROUTES } from "../../../contants/APP_ROUTES";
import { COMMON_EXPENSE_ARRAY } from "../../../contants/COMMON_EXPENSE_ARRAY";
import { PARAMS } from "../../../contants/PARAMS";
import { QUERY_PARAMS } from "../../../contants/QUERY_PARAMS";
import { DateHelper } from "../../../helpers/DateHelper";
import { Helper } from "../../../helpers/Helper";
import { PageOption } from "../../../models/common/pageOption";
import { Row } from "../../../models/tables/row";
import { DailyTrip } from "../../../models/trips/dailyTrip";
import { DailyTripExpense } from "../../../models/trips/dailyTripExpense";
import { DailyTripFilter } from "../../../models/trips/dailyTripFilter";
import { AlertService } from "../../../services/alert.service";
import { BudgetService } from "../../../services/budget.service";
import { DailyTripService } from "../../../services/daily-trip.service";
import { ParameterService } from "../../../services/parameter.service";
import { MatDialog } from "@angular/material";
import { ZtsiDeleteConfirmationDialogComponent } from "../../shared/ztsi-delete-confirmation-dialog/ztsi-delete-confirmation-dialog.component";
import { EDailyTripTypes } from "../../../enums/daily-trip-types";
import { ReportService } from "../../../services/report.service";

@Component({
  selector: "app-daily-trip-list",
  templateUrl: "./daily-trip-list.component.html",
  styleUrls: ["./daily-trip-list.component.css"],
})
export class DailyTripListComponent implements OnInit {
  pageOption: PageOption<DailyTripFilter> = new PageOption();

  rows: Row<DailyTrip>[] = [];
  isApprover: boolean = false;
  commonExpenses: string[] = COMMON_EXPENSE_ARRAY;
  showEditableTable: boolean = Helper.isManager();
  totals = [
    { typeId: EDailyTripTypes.Import, label: "Import", total: 0 },
    { typeId: EDailyTripTypes.Export, label: "Export", total: 0 },
    { typeId: EDailyTripTypes.Domestic, label: "Domestic", total: 0 },
    { typeId: EDailyTripTypes.ReturnEmpty, label: "Empty", total: 0 }
  ];

  budget: number;
  
  now = new Date();
  tripCounts: { previous: number; current: number; } = null;


  constructor(
    private _dailyTripService: DailyTripService,
    private _alertService: AlertService,
    private _parameterService: ParameterService,
    private _reportService: ReportService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _budgetService: BudgetService,
		private _dialog: MatDialog
  ) {}

  ngOnInit() {
    this.pageOption.searchFilter = new DailyTripFilter();
    this.isApprover = Helper.isManager();
    this.getBudget();

    this._parameterService
      .getCachedSystemParameterArray<string>(
        PARAMS.DAILY_TRIP_COMMON_EXPENSE,
        3600
      )
      .subscribe((result) => {
        if (result.length != 0) {
          this.commonExpenses = result;
        }
      });

    if(Helper.isManager()){
      this._reportService.getDailyTripCountSummary().subscribe(
        result => {
          if(result != undefined){
            this.tripCounts = {
              previous: result.dailyTripPreviousYearCount,
              current: result.dailyTripCurrentYearCount
            };          
          }
        }
      );
    }    

    this._activatedRoute.queryParams.subscribe((params) => {
      var filter = new DailyTripFilter();
      let isDateNowString = params["isDateNow"];
      if (isDateNowString && isDateNowString.toLowerCase() == "true") {
        filter.tripDateFrom = DateHelper.getDateNowString();
        filter.tripDateTo = DateHelper.getDateNowString();
      }

      if (params[QUERY_PARAMS.TRIP_ID] != undefined) {
        filter.tripId = params[QUERY_PARAMS.TRIP_ID];
      }

      this._parameterService
        .getCachedParameter<number>(
          PARAMS.DAILY_TRIP_TABLE_DEFAULT_PAGE_SIZE,
          3600
        )
        .subscribe((value) => {
          value = Number(value);
          this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
          this.pageOption.pageNumber = 1;

          this.search(filter);
        });
    });
  }

  fetchData() {
    this._dailyTripService
      .getDailyTripsList(this.pageOption)
      .subscribe((result) => {
        if (result.data != undefined) {
          if (this.pageOption.pageTotal <= 0) {
            this.pageOption.pageTotal = result.totalPages;
          }

          let index = (result.pageNumber - 1) * this.pageOption.pageSize;
          result.data.forEach((x) => {
            let row = new Row<DailyTrip>();
            row.status = "loaded";
            row.object = x;
            this.rows[index] = row;
            index++;
          });

          this.totals.forEach(x => x.total = 0);
          this.totals.forEach(x => {
            result.data.filter(d => d.dailyTripTypeId == x.typeId).forEach(d => x.total++);
          });
        }    
      });
  }

  onFetchNextData(pageNumber: number) {
    this.pageOption.pageNumber = pageNumber;
    this.fetchData();
  }

  saveRow(index: number) {
    let dailyTrip = this.rows[index].object;

    if (dailyTrip.id == undefined || dailyTrip.id == 0) {
      this.createDailyTrip(index, dailyTrip);
    } else {
      this.updateDailyTrip(index, dailyTrip);
    }
  }

  addRow() {
    let row = new Row<DailyTrip>();
    row.status = "new";
    row.object = new DailyTrip();
    row.object.tripDate = DateHelper.getDateNowString();
    row.object.dailyTripExpenses = [];
    row.object.bookKeeperId = Helper.currentUserId();

    this.rows.push(row);
  }

  removeRow(index: number) {    
    this._dialog.closeAll();
		let dialogRef = this._dialog.open(ZtsiDeleteConfirmationDialogComponent, {
		  width: "550px"
		});
	
		dialogRef.afterClosed().subscribe((confirm: boolean) => {
		  if (!confirm) return;

      let id = this.rows[index].object.id;
      this.rows.splice(index, 1);

      //call delete
      if (id != 0) {
        this._dailyTripService.deleteDailyTrip(id).subscribe((result) => {
          if (result == undefined) {
            this._alertService.showGenericError();
          } else if (result.errors.length > 0) {
            this._alertService.displayErrorResult(result);
          }
        });
      }
		});    
  }

  goToFormView(id: number) {
    this._router.navigate([APP_ROUTES.dailyTripForm.replace("/:id", ""), id]);
  }

  onExpenseAmountChange(evt, rowIndex: number, expenseType: string) {
    let value = Number(evt.target.value);
    if (isNaN(value)) {
      return;
    }

    //findExpenseTypeIndex will create new item if expenseType didn't exist
    let expenseTypeIndex = this.findExpenseTypeIndex(rowIndex, expenseType);
    this.rows[rowIndex].object.dailyTripExpenses[expenseTypeIndex].amount =
      value;
  }

  findExpenseTypeIndex(rowIndex: number, expenseType: string) {
    let expenseTypeIndex = this.rows[
      rowIndex
    ].object.dailyTripExpenses.findIndex((x) => x.expenseType == expenseType);

    if (expenseTypeIndex == -1) {
      let expense = new DailyTripExpense();
      expense.id = 0;
      expense.expenseType = expenseType;
      expense.amount = 0;

      this.rows[rowIndex].object.dailyTripExpenses.push(expense);
      return this.rows[rowIndex].object.dailyTripExpenses.length - 1;
    }

    return expenseTypeIndex;
  }

  private createDailyTrip(index: number, newDailyTrip: DailyTrip) {
    this._dailyTripService.addDailyTrip(newDailyTrip).subscribe((result) => {
      if (result.object != undefined) {
        this.updateObject(index, result.object);
        this._alertService.showSuccess("DailyTrip registered.");
      } else {
        this.rows[index].hasError = true;
        this._alertService.displayErrorResult(result.errorCollection);
      }
    });
  }

  private updateDailyTrip(index: number, existingDailyTrip: DailyTrip) {
    this._dailyTripService
      .updateDailyTrip(existingDailyTrip)
      .subscribe((result) => {
        if (result.object != undefined) {
          this.updateObject(index, result.object);
          this._alertService.showSuccess("DailyTrip data updated.");
        } else {
          this.rows[index].hasError = true;
          this._alertService.displayErrorResult(result.errorCollection);
        }
      });
  }

  private updateObject(index: number, object: DailyTrip) {
    this.rows[index].object = object;
    this.rows[index].hasError = false;
    this.getBudget();
  }

  search(filter: DailyTripFilter) {
    if (filter.tripDateFrom && !filter.tripDateTo) {
      filter.tripDateTo = filter.tripDateFrom;
    }

    this.pageOption.searchFilter = filter;

    this.rows = []; //reset array
    this.fetchData();
  }

  getTotal(prop) {
    let total = 0;
    this.rows.forEach((row) => {
      let value = Number(row.object[prop]);
      total += isNaN(value) ? 0 : value;
    });

    return total;
  }

  private getBudget() {
    this._budgetService.getTotalBudget().subscribe((result) => {
      if (result != undefined) {
        this.budget = result;
      }
    });
  }

  export() {
    if (
      !this.pageOption.searchFilter.tripDateFrom ||
      !this.pageOption.searchFilter.tripDateTo
    ) {
      this._alertService.showError("Select a trip date using the filter.");
      return;
    }

    this._dailyTripService
      .exportDailyTrip(
        this.pageOption.searchFilter.tripDateFrom,
        this.pageOption.searchFilter.tripDateTo
      )
      .subscribe((result) => {
        var blob = new Blob([result], { type: "application/vnd.ms-excel" });
        saveAs(
          blob,
          `Daily Trip (${this.pageOption.searchFilter.tripDateFrom}-${this.pageOption.searchFilter.tripDateTo}).xlsx`
        );
      });

    this._dailyTripService.exportDailyTrip(
      this.pageOption.searchFilter.tripDateFrom,
      this.pageOption.searchFilter.tripDateTo
    );
  }

  getTypesTotal(){
    let total = 0;
    this.totals
      .filter(x => x.typeId !== EDailyTripTypes.ReturnEmpty)
      .forEach(x => total += x.total);
      
    return total;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/trips/daily-trip-list/daily-trip-list.component.ts